module.exports = __webpack_public_path__ + "static/media/vienna-10.a53665fd.jpg";